import React from 'react';
import { Link } from 'react-router-dom';
import { useQueries } from '@tanstack/react-query';
import { rupees, shopApi, useSavedOrders, type PublicOrder } from './shopApi';

/** Orders placed on this phone that still need paying - e.g. after the UPI
 * app failed and the customer came back: the cart is empty (the items are in
 * the order now), so point them to the order instead. */
export function AwaitingPayment() {
  const saved = useSavedOrders().slice(0, 5);
  const results = useQueries({
    queries: saved.map((s) => ({ queryKey: ['shop-order', s.ref], queryFn: () => shopApi.get(s.ref, s.token), retry: 0, staleTime: 15_000 })),
  });
  const unpaid = results.map((r) => r.data).filter((o): o is PublicOrder => !!o && o.can_pay);
  if (!unpaid.length) return null;
  return (
    <div className="flex flex-col gap-2">
      {unpaid.map((o) => (
        <Link key={o.ref} to={`/shop/order/${o.ref}`} className="flex items-center gap-3 rounded-xl border-2 border-brand-gold-400 bg-brand-gold-50 p-3">
          <div className="min-w-0 flex-1">
            <p className="text-sm font-bold text-brand-gold-900">Order {o.ref} is waiting for payment</p>
            <p className="text-xs text-brand-gold-800">{o.items.map((i) => `${i.name} ${i.pack_label} × ${i.quantity}`).join(', ')}</p>
          </div>
          <span className="shrink-0 rounded-lg bg-brand-green-700 px-3 py-2 text-sm font-bold text-white">Pay {rupees(o.total)}</span>
        </Link>
      ))}
    </div>
  );
}

